import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { VatRowDTO } from "../../api/vat";
import { formatCurrencyAmount } from "../../utils/formatters";
import { useAppTranslation } from "../../hooks/useAppTranslation";
import { formatVatRate, normalizeVatRate } from "../../utils/formatVatRate";

type Props = {
  rows: VatRowDTO[];
};

const VAT_RATE_ORDER = ["23", "8", "5", "0", "NP", "ZW"];

export default function VatTable({ rows }: Props) {
  const { t } = useAppTranslation("common");
  const sortedRows = [...rows].sort((a, b) => {
    const rateA = normalizeVatRate(a.VATPercent).toUpperCase();
    const rateB = normalizeVatRate(b.VATPercent).toUpperCase();
    const indexA = VAT_RATE_ORDER.indexOf(rateA);
    const indexB = VAT_RATE_ORDER.indexOf(rateB);

    if (indexA === -1 && indexB === -1) {
      return rateA.localeCompare(rateB);
    }

    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    <Table size="small">
      <TableHead sx={{ backgroundColor: "grey.100" }}>
        <TableRow>
          <TableCell>{t("Stawka VAT")}</TableCell>
          <TableCell align="right">{t("Podstawa")}</TableCell>
          <TableCell align="right">{t("Kwota VAT")}</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {sortedRows.map((row, idx) => (
          <TableRow
            key={idx}
            sx={{
              "&:nth-of-type(odd)": {
                backgroundColor: "grey.50",
              },
            }}
          >
            <TableCell>{formatVatRate(row.VATPercent)}</TableCell>
            <TableCell align="right">
              {formatCurrencyAmount(row.VATBaseAmount)}
            </TableCell>
            <TableCell align="right">
              {formatCurrencyAmount(row.VATAmount)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
